import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNdrComponent } from './simple-icons-ndr.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNdrComponent ],
    exports:      [ SimpleIconsNdrComponent ],
    bootstrap:    []
})
export class SimpleIconsNdrModule {}
